import HomepageVideo from './HomepageVideo';

export default HomepageVideo;
